module.exports = __webpack_public_path__ + "img/order-delivery.327887e6.png";